import { HStack, Switch } from '@chakra-ui/react';
import { Field } from 'formik';

const AllowUnlimitedRowsField = ({
    values,
    setFieldValue,
    FormFieldWithTooltip,
}) => {
    return (
        <FormFieldWithTooltip
            label="Allow to fetch more than 11000 rows"
            tooltipLabel="Toggle to allow fetching more than 11,000 rows. This may impact performance with very large dataset"
            fieldKey="allowUnlimited"
            helperText="Highest number of rows allowed to be fetched - 11 000 or unlimited"
            top="4px">
            <Field name="allowUnlimited">
                {({ field }) => (
                    <HStack height="30px" alignItems="center">
                        <Switch
                            {...field}
                            id="allowUnlimited"
                            isChecked={values?.allowUnlimited || false}
                            onChange={(e) => {
                                setFieldValue(
                                    'allowUnlimited',
                                    e.target.checked,
                                );
                            }}
                            colorScheme="brand"
                            size="md"
                        />
                    </HStack>
                )}
            </Field>
        </FormFieldWithTooltip>
    );
};

export default AllowUnlimitedRowsField;
